// Global Guards
/* eslint-disable */

const beforeEach = (to, from, next) => {
  var usertoken = JSON.stringify(window.localStorage.getItem("pitmsToken"));
  const authUser = JSON.parse(usertoken);
  if (to.meta.requiresAuth) {
    if (authUser) {
      next();
    } else {
      next({ name: "Login" });
    }
  }
  next();
};

const login = (to, from, next) => {
  if (localStorage.getItem('pitmsToken')) {
    next({name: 'Dashboard'})
  }
  next()
};

const afterEach = (to, from) => {
  // Put your guard actions here
};

export default {
  beforeEach,
  login,
  afterEach,
};
